export * from "../global/diamond";
